module.exports = __webpack_public_path__ + "img/統計学入門_1_7_問題.89406d1d.jpeg";